module.exports = "https://static.wmbcdn.com/uniweb/images/6330baac30d89e364a46e2ee78029eab.svg";